import Skeleton from "./skeleton";
import { convertToFullName, createDummyArray } from "../../../services/utils";
import { concatSelectedFromToTime } from "../../../services/utils/date-and-time.utils";
import RecordingCard from "./RecordingCard/RecordingCard";
import { Grid, Stack } from "@mui/material";
import NoDataFound from "../../../templates/NoDataFound";
import { SomethingWentWrong } from "../../../components/form/errors";

export default function RecordingList({ fetching, list, role, isError }) {
  if (fetching) {
    return <Stack gap={2}> {createDummyArray(3).map((_, index) => <Skeleton key={index} />)}</Stack>;
  }

  if (isError) {
    return <SomethingWentWrong />
  }

  if (!list || list.length === 0) {
    return <NoDataFound />
  }

  return (
    <Grid container spacing={2}>
      {list.map((rec, idx) => (
        <Grid key={rec?.id ?? idx} item xs={12}>
          <RecordingCard
            data={{
              ...rec,
              title: rec?.[role]?.title,
              name: convertToFullName(rec?.[role]),
              company: rec?.[role]?.company,
              selectedTimeSlot: concatSelectedFromToTime(rec?.selectedTimeSlot),
              selectedTimeSlotRaw: rec?.selectedTimeSlot,
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
